import App from './app';
import { h, render } from 'preact';
import $ from 'jquery';
import swal from 'sweetalert2';

import { TranslateProvider } from "@denysvuika/preact-translate";

function onPause() {
  console.log('pause');
  // Handle the pause event
}

function onResume() {
  console.log('resume');
}

function onMenuKeyDown() {
  console.log('menu');
}

function onBack() {
  if (window.navigator.app && window.navigator.app.exitApp) {
    if (swal.isVisible()) {
      window.swal.close();
    } else if ($('.offcanvas.show').length) {
      $('.offcanvas.show').find('[data-bs-dismiss="offcanvas"]')[0].click();
    } else {
      if (window.location.pathname == '/') {
        window.navigator.app.exitApp();
      } else {
        history.go(-1)
      }
    }
  }
}

const startApp = (lang) => {
  document.addEventListener("pause", onPause.bind(this), false);
  document.addEventListener("resume", onResume.bind(this), false);
  document.addEventListener("menubutton", onMenuKeyDown.bind(this), false);
  document.addEventListener("backbutton", onBack, false);
  window.onBack = onBack;
  render(<TranslateProvider root="/i18n" lang={lang}>
            <App />
          </TranslateProvider>, document.getElementById('app'))
}

if (!window.cordova) {
  startApp('ru')
} else {
  document.addEventListener('deviceready', async () => {
    startApp('ru')
    console.log('Device Start');
    await admob.start(); // or start loading ads

    // Only call this the first time
    let webViewAd = new admob.WebViewAd({
      src: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
      adsense: 'ca-app-pub-4962355497473040~1181518173', // Your adsense account
      npa: nonPersonalizedAds ? '1' : '',
    });

    await admob.prepare();
    let banner = new admob.BannerAd({
      adUnitId: 'ca-app-pub-3940256099942544/6300978111',
    })
  
    banner.on('impression', async (evt) => {
      await banner.hide()
    })

    webViewAd.addAd({
      element: document.querySelector('.yourAddElement'),
      slot: '000000000', // Ad slot id, supported ads https://support.google.com/admob/answer/6128738
      format: 'horizontal',
      fullWidth: false,
    });

    await banner.show({
      id: 'ca-app-pub-3940256099942544/6300978111',
    })
  }, false)

}
